import React, { useState, useEffect, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import styles from './index.module.less';

export type FixedContainerProps = React.HTMLAttributes<HTMLDivElement> & {
    width?: number | string; //容器宽度
    height?: number | string; //容器高度
    placement?: ['left' | 'right', 'top' | 'bottom']; //坐标
    offset?: [number | string, number | string]; //位移, [x方向位移，y方向位移]
    container?: () => HTMLElement | null;
    zIndex?: number;
    fixed?: boolean; //是否fixed定位，默认是
};

export const FixedContainer = forwardRef<HTMLDivElement, FixedContainerProps>(
    function Container(props, ref) {
        const [browser, setBrowser] = useState<boolean>(false);
        const {
            children,
            className,
            style,
            width = '100%',
            height,
            placement = ['left', 'bottom'],
            offset = [0, 0],
            container,
            zIndex,
            fixed = true,
            ...rest
        } = props;

        useEffect(() => {
            setBrowser(true);
        }, [])

        return browser ? createPortal(
            (
                <div
                    ref={ref}
                    className={cn(styles['fixed-container'], fixed ? 'fixed' : 'relative', className)}
                    style={fixed ? {
                        width,
                        height,
                        [placement[0]]: offset[0],
                        [placement[1]]: offset[1],
                        zIndex: zIndex,
                        ...style
                    } : style}
                    {...rest}
                >
                    {children}
                </div>
            ),
            container ? container() || document.body : document.body
        ) : null;
    }
);


export default FixedContainer;

